"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Add = function Add(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 36 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 36 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'add' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'add' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "path-1",
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    rx: "4"
  }), /*#__PURE__*/_react["default"].createElement("filter", {
    x: "-41.7%",
    y: "-33.3%",
    width: "183.3%",
    height: "183.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "0",
    dy: "2",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    stdDeviation: "3",
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    values: "0 0 0 0 0.599542942   0 0 0 0 0.595556871   0 0 0 0 0.595556871  0 0 0 0.217023324 0",
    type: "matrix",
    "in": "shadowBlurOuter1"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access",
    transform: "translate(-600.000000, -173.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Add",
    transform: "translate(606.000000, 177.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Rectangle-5-Copy-22"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.0190982,17 L11.9809018,8",
    id: "Path-2-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: "1.6875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,12.03894 L17,12",
    id: "Path-2-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: "1.6875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
Add.propTypes = _index.iconProps;
var _default = Add;
exports["default"] = _default;